import { useGetUserConsentQuery, useCreateUserConsentMutation } from "@/store/services/user-consent.service";
import { dayjs } from "@/utils/dayjs";

const isConsentInvalid = (lastAcceptedAt: string | null) => {
    if (!lastAcceptedAt) {
        return true;
    }

    const dayOfConsentExpiration = dayjs(lastAcceptedAt).add(1, "year");
    return dayjs().isAfter(dayOfConsentExpiration);
};

export const useUserConsentGuard = () => {
    const { data, error } = useGetUserConsentQuery();
    const [createUserConsent, { isLoading: isCreateUserConsentLoading }] = useCreateUserConsentMutation();

    let isConsentExpired = false;
    if (error) {
        isConsentExpired = true;
    } else if (data) {
        isConsentExpired = isConsentInvalid(data.lastAcceptedAt);
    }

    const acceptConsent = async () => {
        await createUserConsent({ acceptedAt: dayjs().toISOString() });
    };

    return {
        isConsentExpired,
        acceptConsent,
        isAcceptConsentLoading: isCreateUserConsentLoading,
    };
};
